import { Link } from "react-router-dom";

export default function FinalCta() {
  return (
    <section id="final" className="border-t border-[rgba(255,255,255,0.06)] bg-[#0D111A]">
      <div className="fp-section !py-16 text-center">
        <h2 data-testid="final-cta-headline" className="text-2xl sm:text-3xl font-bold tracking-tight">
          Find out whether you're early or late. It costs nothing.
        </h2>
        <Link to="/register" data-testid="final-cta-btn" className="fp-btn inline-block mt-6 px-10 py-3.5 text-sm">
          Create your free account
        </Link>
      </div>
    </section>
  );
}
